<template>
  <div class="toOwnerview">
    <!-- totoOwner -->
  </div>
</template>

<script>
export default {
  name: 'toOwnerview',
  created() {
    if (process.env.NODE_ENV === 'development') {
      window.open('测试地址');
    } else if (process.env.NODE_ENV === 'production') {
      window.open('生产地址');
    }

    this.$router.go(-1);
  },
};
</script>

<style>
</style>
